export enum PayslipTypeEnum {
  REGULAR = 'regular',
  INCENTIVE = 'incentive',
  PPD = 'PPD',
}

export enum DepartmentEnum {
  OPS = 'Ops',
  HR = 'HR',
}

export enum PayslipOwnerEnum {
  PEOPLE = 'People',
  OPERATIONS = 'Operations',
}

export enum PayslipCategoryEnum {
  INCOME = 'Pendapatan',
  INCENTIVE = 'Insentif',
  DEDUCTION = 'Potongan',
}

export interface MasterRateApiItemInterface {
  id: number
  role: string
  base_pay: string
  ho: string
  ho2: string
  ot_2_4: string
  ot_4: string
  half_day: string
  onleave: string
  volunteer: string
  effective_date: string
  rate_type: string
}

export interface GetMasterRateListResponseInterface {
  data: MasterRateApiItemInterface[]
  pagination: {
    prev_cursor: string
    next_cursor: string
  }
}

export enum BulkUploadApiStatusEnum {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
}

export enum MasterPayrollBulkUploadTemplateTypeEnum {
  ATTRIBUTE = 'attribute',
  VALIDATION = 'validation',
}

export const parseMasterPayrollBulkUploadTemplateType = (
  raw: string | undefined,
): MasterPayrollBulkUploadTemplateTypeEnum | undefined => {
  switch (raw) {
    case MasterPayrollBulkUploadTemplateTypeEnum.ATTRIBUTE:
      return MasterPayrollBulkUploadTemplateTypeEnum.ATTRIBUTE
    case MasterPayrollBulkUploadTemplateTypeEnum.VALIDATION:
      return MasterPayrollBulkUploadTemplateTypeEnum.VALIDATION
    default:
      return undefined
  }
}

export interface MasterRateBulkUploadResponseInterface {
  url_download: string
  total_data: number
  success_data: number
  failed_data: number
  status: BulkUploadApiStatusEnum
}

export enum VendorAccessModuleEnum {
  PAYSLIP = 'payslip',
}

export interface VendorAccessItemInterface {
  vendor_id: number
  module: string
  is_allowed: boolean
  vendor_name: string
}

export interface GetVendorAccessByModuleResponseInterface {
  data: VendorAccessItemInterface[]
  error: {
    status: boolean
    message: string
    code: number
  }
}

export interface PostVendorAccessResponseInterface {
  message: string
  error: {
    status: boolean
    code: number
    message: string
  }
}

export enum PayrollStatusEnum {
  WAITING_OPS_HR_SUBMISSION = '1',
  WAITING_OPS_SUBMISSION = '2',
  WAITING_HR_SUBMISSION = '3',
  WAITING_FOR_VALIDATION = '4',
  READY_TO_PUBLISH = '5',
  PUBLISHED = '6',
}

export interface MasterPayrollListItemInterface {
  vendor: string
  payroll_status: string
  staff_id: number
  payroll_id: number
  location_id: number
  amount: string
  payroll_status_string: string
  staff_name: string
  hired_role: string
  location_type: string
  location_name: string
  employment_type: string
  payroll_type: string
}

export interface GetMasterPayrollListV2ResponseInterface {
  pagination: {
    prev_cursor: string
    next_cursor: string
  }
  data: MasterPayrollListItemInterface[]
  error: {
    status: boolean
    message: string
    code: number
  }
}

export interface GetMasterPayrollListServicesInterface {
  data: MasterPayrollListItemInterface[]
  pagination: GetMasterPayrollListV2ResponseInterface['pagination']
}

export interface GetPayrollDetailByUserIdServicesInterface {
  data: {
    id: string
    staff_id: string
    staff_name: string
    payroll: {
      id: string
      start_date: string
      end_date: string
      period: string
      payroll_type: string
      total_amount: string
    }[]
  }
  pagination: {
    number_of_elements: number
    page_index: number
  }
}

export interface PayrollQueryParamsInterface {
  sort: string
  direction: string
  pageSize: number
  pageIndex: number
  numberOfElements: number
  cursor: string
  nextCursor: string
}

export interface PayrollAttributeApiItemInterface {
  id: number
  attribute: string
  payout_type: string
  sort_order: number
  is_visible: boolean
  effective_date: string
  label: string
  owner: string
  category: string
}

export interface GetPayrollAttributesResponseInterface {
  data: {
    category: string
    attributes: PayrollAttributeApiItemInterface[]
  }[]
}

export interface MasterPayrollValidateDetailDataInterface {
  payout_type?: string
  informasi_potongan?: string
  detail_kehadiran: {
    ho: number
    ho2: number
    days: number
    ot_4: number
    role: string
    ot_2_4: number
    onleave: number
    half_day: number
    ontime: number
    late_lt_15: number
    late_gt_15: number
  }[]
  pendapatan_lainnya: {
    name: string
    value: number
  }[]
  potongan: {
    name: string
    value: number
  }[]
  staff_info: {
    staff_id?: number
    nik: string
    name: string
  }
  periode_komisi: string
  location_id: number
  location_name?: string
  informasi_transfer: {
    nama_bank: string
    nomor_rekening: string
    nama_pemilik_rekening: string
  }
  kehadiran: {
    onleave: number
    half_day: number
    lembur_ho: number
    volunteer: number
    hari_kerja: number
    lembur_2_4: number
    lembur_ho2: number
    lembur_greater_4: number
    ontime: number
    late_lt_15: number
    late_gt_15: number
  }
  pendapatan: {
    role: string
    harian: number
    setengah_hari: number
    izin: number
    lembur_2_4: number
    lembur_4: number
    ho: number
    ho2: number
  }[]
  total: {
    total_potongan: number
    total_upah_lembur: number
    total_komisi_ho: number
    total_komisi_bersih: number
    total_komisi_hari_kerja: number
    total_pendapatan_lainnya: number
    total_komisi_izin_berbayar: number
    total_komisi_setengah_hari: number
    total_komisi_tepat_waktu: number
    total_komisi_telat_dibawah_15_menit: number
    total_komisi_telat_diatas_15_menit: number
  }
}

export interface GetMasterPayrollValidateDetailResponseInterface {
  data: MasterPayrollValidateDetailDataInterface
  error: null | {
    status: boolean
    message: string
    code: number
  }
}
